import { render, staticRenderFns } from "./Notat.vue?vue&type=template&id=70a20f15"
import script from "./Notat.vue?vue&type=script&lang=js"
export * from "./Notat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports